/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ComponentManagerFn } from '../../registry/Component.type';
import { ItemType } from '../../registry/ComponentRegistry';
import { baseComponentManager } from '../../registry/Components';
import { defaultValue } from './CommentActionMenuItems';

const CommentActionMenuItemsManager: ComponentManagerFn<
  'CommentActionMenuItems'
> = (platform: Platform) => {
  return {
    ...baseComponentManager<'CommentActionMenuItems'>(
      platform,
      'CommentActionMenuItems',
    ),
    type: 'CommentActionMenuItems',
    name: 'Comment Action Menu Items',
    isChildAllowed: (page, item, childType) =>
      (['MenuItem', 'MenuItemDivider'] as ItemType[]).includes(childType),
    defaultValue,
    props: {},
    category: 'Data',
    showEmptyPlaceholderInDesignerView: false,
    noOverlay: true,
    icon: { iconName: 'list-alt' },
    description: `A placeholder component to hold all the custom menu items to be added for comment actions menu.
\`\`\`javascript
// Access the comment information as below using expression in menu items actions.
\`\${$._.comment.commentedBy} \${$._.comment.commentText} \${$._.comment.commentUid}\`
\`\`\``,
  };
};

export default CommentActionMenuItemsManager;
